// main.js
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import id from './locales/id.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import th from './locales/th.json';
import vn from './locales/vn.json';
Vue.use(VueI18n);
/***
 * 根据用户语言设置语言
 * 默认为zh
 * 路由守卫会查询url是否有language参数，如果有则优先使用url的language参数
 **/
const messages = { en, id, es, pt, zh, th, vn };
const userLang = navigator.language || navigator.userLanguage;

const langMap = { 'id': 'id', 'pt': 'pt', 'es': 'es', 'zh':"zh", 'th':"th", 'vn':"vn"};
const langPrefix = userLang.split('-')[0].toLowerCase();
const defaultLang = 'en';
const locale = langMap[langPrefix] || defaultLang;

const i18n = new VueI18n({
  locale,
  messages,
});


Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
export { i18n }; // 导出 i18n 实例
